// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__JLjEp","content":"RecentSearches_content__sT0DD"};